import { useEffect, useState } from 'react';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { FnAxios, FnDialog } from 'utilities/utilities';
import ProjectRequestFrom from 'view/FrontEnd/Project/ProjectRequestFrom';

const ProjectCheckRecordFrom = () => { //ตรวจสอบ/บันทึกผล > โครงการที่ขอรับการสนับสนุน
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const [isPermission, setPermission] = useState<boolean>(true); //false // Permission true = Edit | false = View, Disabled
    
    useEffect(() => {       
        GetMenuPermission(AxiosFn, setPermission, DialogFn);     
    }, []);

    return ( <ProjectRequestFrom />)
}
export default ProjectCheckRecordFrom;